import React, { FC, useState } from "react"
import "../../styles/Catalog.css"
import Loading from "../../../../ui/Loading"
import { Plus, X } from "heroicons-react"
import { KInput, KSpan, KTitleSpan } from "kahuna-base-react-components"
import { lang } from "../../../../../constants/languages"
import { releases } from "../../../../../apis"

interface TrackFromCatalogProps {
  loading: boolean
  trackFromCatalogOpen: boolean
  setTrackFromCatalogOpen: (trackFromCatalogOpen: boolean) => void
  fetchProduct: (productId: string) => void
  productId?: string
}

interface TrackSearchAttributes {
  artist: string[]
  "isrc-code": string
  subtitle: string
  title: string
}

interface TrackSearch {
  attributes: TrackSearchAttributes
  id: string
  relationships: { [key: string]: any }
}

const TrackFromCatalog: FC<TrackFromCatalogProps> = (props) => {
  const { loading, trackFromCatalogOpen, setTrackFromCatalogOpen, fetchProduct, productId } = props

  const [tracks, setTracks] = useState<TrackSearch[]>([])
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout>()
  const [searchText, setSearchText] = useState<string>("")
  const [searchLoading, setSearchLoading] = useState(false)

  const onSearch = (search: string) => {
    setSearchText(search)
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    if (!search || search.length < 2) {
      return
    }
    setTimeoutId(
      setTimeout(async () => {
        setSearchLoading(true)
        releases(`/release/label_camp_track_search/?search=${search}`, "get").then((resp) => {
          setSearchLoading(false)
          if (resp.data?.data) {
            setTracks(resp.data.data)
          }
        })
      }, 1000)
    )
  }

  const cloneTrack = (track: TrackSearch) => {
    if (!productId) {
      return
    }
    
    setSearchLoading(true)
    releases(`/release/clone_track/?product_id=${productId}&track_id=${track.id}`, "put").then((resp) => {
      setSearchLoading(false)
      if (resp?.data?.success) {
        setTrackFromCatalogOpen(false)
        fetchProduct(productId)
      }
    })
  }

  return (
    <div>
      {loading && <Loading />}
      {trackFromCatalogOpen && (
        <div
          className="fixed inset-0 flex items-end justify-end h-[100%] overflow-auto"
          style={{ zIndex: 9, background: "rgba(4, 3, 3, 0.57)" }}
        >
          <div className="mt-10 bg-white elev-b-sm overflow-auto h-[100%] w-[50%] justify-end">
            <div
              className={`bg-gray-50 text-xs text-gray-500 font-medium uppercase border-b flex justify-between p-4 items-center`}
            >
              <KTitleSpan
                text={lang.catalog.asset_registry.tracks_and_assets.track_from_my_catalog}
                fontSize={16}
                lineHeight="20px"
              />
              <X className="h-4 cursor-pointer" onClick={() => setTrackFromCatalogOpen(false)} />
            </div>
            <div className="p-4">
              <div className="w-[90%] max-w-[300px]">
                <KInput
                  onChange={(text: string) => onSearch(text)}
                  value={searchText}
                  placeholder={lang.catalog.asset_registry.tracks_and_assets.search_by_title_isrc_artist}
                  padding="14px"
                  leftIcon="/catalog_icons/search-grey.svg"
                  hoverBackground="white"
                  background="#F5F5F5"
                />
              </div>
            </div>
            {searchLoading && <Loading />}
            <div className="p-4">
              <div className="flex" style={{ width: "100%" }}>
                <div style={{ width: "30%" }}>
                  <KTitleSpan fontSize={14} text={lang.catalog.release_detail.track_title} lineHeight="16px" />
                </div>
                <div style={{ width: "35%" }}>
                  <KTitleSpan fontSize={14} text="Artist" lineHeight="16px" />
                </div>
                <div style={{ width: "20%" }}>
                  <KTitleSpan fontSize={14} text="ISRC" lineHeight="16px" />
                </div>
                <div style={{ width: "15%" }}></div>
              </div>
              {tracks.map((track) => {
                return (
                  <div key={track.id} style={{ borderTop: "1px solid #00000010" }} className="mt-4 pt-4">
                    <div className="flex gap-2" style={{ width: "100%" }}>
                      <div style={{ width: "30%" }}>
                        <KSpan text={track.attributes?.title} />
                      </div>
                      <div style={{ width: "35%" }}>
                        <KSpan text={track.attributes?.artist?.join(", ")} />
                      </div>
                      <div style={{ width: "20%" }}>
                        <KSpan text={track.attributes?.["isrc-code"]} />
                      </div>
                      <div className="flex justify-end pr-6" style={{ width: "15%" }}>
                        <Plus className="w-6 h-6 text-gray-500 cursor-pointer" onClick={() => cloneTrack(track)} />
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default TrackFromCatalog
